import * as React from 'react';
import './EventParticipantIdentity.scss';

interface Props {
  firstName?: string;
  lastName?: string;
  isOwned: boolean;
  avatar?: string;
  ownedLabel: 'Your child' | 'You';
}

export const EventParticipantIdentity = ({ firstName = '', lastName = '', isOwned, avatar, ownedLabel }: Props) => {
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase() || '?';
  const hasOwnedAvatar = isOwned && !!avatar;

  return (
    <span className="eventParticipantIdentity">
      <span
        className={`eventParticipantIdentity__avatar ${isOwned ? 'is-owned' : ''}`}
        style={hasOwnedAvatar ? { backgroundImage: `url(${avatar})` } : undefined}
        aria-hidden="true"
      >
        {hasOwnedAvatar ? null : initials}
      </span>
      <span className="eventParticipantIdentity__copy">
        <span className="eventParticipantIdentity__name">{firstName}</span>
        {isOwned ? <span className="eventParticipantIdentity__badge">{ownedLabel}</span> : null}
      </span>
    </span>
  );
};

EventParticipantIdentity.displayName = 'EventParticipantIdentity';
